import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { CloseIcon, SearchIcon, TextField } from "@flat-ui";
import { InputAdornment } from "@mui-wrapper";
/** A search text field with search icon and clear icon */
export function SearchTextField(t0) {
  const $ = _c(15);
  const {
    placeholder,
    searchText,
    onClearClicked,
    onChangeSearch,
    isError,
    sx,
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "aria-label": "search"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isError) {
    t2 = {
      error: isError
    };
    $[1] = isError;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <InputAdornment position="start"><SearchIcon /></InputAdornment>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClearClicked || $[5] !== searchText.length) {
    t4 = searchText.length > 0 && <InputAdornment position="end"><SphereIconButton component={CloseIcon} onClick={onClearClicked} buttonSize="24px" iconSize="18px" /></InputAdornment>;
    $[4] = onClearClicked;
    $[5] = searchText.length;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onChangeSearch || $[8] !== placeholder || $[9] !== searchText || $[10] !== sx || $[11] !== t2 || $[12] !== t4 || $[13] !== variant) {
    t5 = <TextField fullWidth={true} variant={variant} placeholder={placeholder} text={searchText} onTextChanged={onChangeSearch} inputProps={t1} InputProps={t2} controlStyle={sx} startAdornment={t3} endAdornment={t4} />;
    $[7] = onChangeSearch;
    $[8] = placeholder;
    $[9] = searchText;
    $[10] = sx;
    $[11] = t2;
    $[12] = t4;
    $[13] = variant;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}